import { createLazyComponent, LazyModule, LazyAction, LazyImport } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "RoomSelector" */ './lazyIndex')
);

// Lazy OWA exports
export const RoomSelector = createLazyComponent(lazyModule, m => m.RoomSelector);
export const lazyShowRoomPanel = new LazyAction(lazyModule, m => m.showRoomPanel);

// Lazy OPX exports
export const RoomPanelOpx = createLazyComponent(lazyModule, m => m.RoomPanelOpx);
export const lazyInitializeOpxData = new LazyAction(lazyModule, m => m.initializeOpxData);

// Lazy utilities
export const lazyGetRoomFreeBusy = new LazyImport(lazyModule, m => m.getRoomFreeBusy);

export const lazyPrefetchRoomsAvailabilityForRoomPanel = new LazyAction(
    lazyModule,
    m => m.fetchRoomsAvailabilityForRoomPanel
);

export { initializeRoomList } from './actions/calendarRoomActions';

export * from './components/RoomSelector/RoomSelector.types';
